// Italian locale formatting + enum labels

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function fmtEUR(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

export function fmtNum(v) {
  return new Intl.NumberFormat("it-IT").format(Number(v || 0));
}

export function relativeDays(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const diff = Math.round((d - new Date()) / 86400000);
  return diff;
}

export function initials(name = "") {
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

export const LABELS = {
  classification: {
    prospect: "Potenziale cliente", lead: "Lead", cliente: "Cliente", ex_cliente: "Ex cliente",
    partner: "Partner", fornitore: "Fornitore", competitor: "Competitor", associazione: "Associazione / Istituzione", altro: "Altro",
  },
  contact_type: {
    referente: "Referente aziendale", prospect: "Potenziale cliente", cliente: "Cliente", agente: "Agente",
    collaboratore: "Collaboratore", consulente: "Consulente", partner: "Partner", fornitore: "Fornitore", altro: "Altro",
  },
  contact_status: {
    non_contattato: "Non contattato", da_contattare: "Da contattare", contattato: "Contattato",
    in_conversazione: "In conversazione", interessato: "Interessato", meeting: "Meeting",
    opportunita: "Opportunità", cliente: "Cliente", non_interessato: "Non interessato",
    followup_futuro: "Follow-up futuro",
  },
  lead_status: {
    nuovo: "Nuovo", da_verificare: "Da verificare", qualificato: "Qualificato",
    da_contattare: "Da contattare", contattato: "Contattato", risposta_ricevuta: "Risposta ricevuta",
    interessato: "Interessato", meeting_fissato: "Meeting fissato", convertito: "Convertito",
    non_qualificato: "Non qualificato",
  },
  opp_status: { open: "Aperta", won: "Vinta", lost: "Persa" },
  activity_type: {
    telefonata: "Telefonata", email: "Email", linkedin: "LinkedIn", whatsapp: "WhatsApp",
    meeting: "Meeting", "video call": "Video Call", "follow-up": "Follow-up", task: "Task",
    nota: "Nota", altro: "Altro",
  },
  activity_status: { da_fare: "Da fare", in_corso: "In corso", completata: "Completata", annullata: "Annullata" },
  priority: { alta: "Alta", media: "Media", bassa: "Bassa" },
  project_status: {
    da_avviare: "Da avviare", attivo: "Attivo", in_attesa: "In attesa",
    completato: "Completato", rinnovato: "Rinnovato", chiuso: "Chiuso",
  },
  role: {
    admin: "Administrator", manager: "Manager", sales: "Sales / BD",
    collaborator: "Collaborator", readonly: "Read Only",
  },
};

export function label(group, key) {
  return (LABELS[group] && LABELS[group][key]) || key || "—";
}

// Color classes for status pills
export const STATUS_COLORS = {
  nuovo: "bg-blue-50 text-blue-700 border-blue-200",
  da_verificare: "bg-amber-50 text-amber-700 border-amber-200",
  qualificato: "bg-teal-50 text-teal-700 border-teal-200",
  da_contattare: "bg-slate-100 text-slate-700 border-slate-200",
  contattato: "bg-indigo-50 text-indigo-700 border-indigo-200",
  risposta_ricevuta: "bg-cyan-50 text-cyan-700 border-cyan-200",
  interessato: "bg-emerald-50 text-emerald-700 border-emerald-200",
  meeting_fissato: "bg-violet-50 text-violet-700 border-violet-200",
  meeting: "bg-violet-50 text-violet-700 border-violet-200",
  convertito: "bg-emerald-100 text-emerald-800 border-emerald-300",
  non_qualificato: "bg-red-50 text-red-700 border-red-200",
  non_interessato: "bg-red-50 text-red-700 border-red-200",
  open: "bg-blue-50 text-blue-700 border-blue-200",
  won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  lost: "bg-red-50 text-red-700 border-red-200",
  cliente: "bg-emerald-50 text-emerald-700 border-emerald-200",
  prospect: "bg-slate-100 text-slate-700 border-slate-200",
  partner: "bg-indigo-50 text-indigo-700 border-indigo-200",
  competitor: "bg-red-50 text-red-700 border-red-200",
  fornitore: "bg-amber-50 text-amber-700 border-amber-200",
  associazione: "bg-cyan-50 text-cyan-700 border-cyan-200",
  referente: "bg-slate-100 text-slate-700 border-slate-200",
  agente: "bg-violet-50 text-violet-700 border-violet-200",
  collaboratore: "bg-teal-50 text-teal-700 border-teal-200",
  consulente: "bg-indigo-50 text-indigo-700 border-indigo-200",
  alta: "bg-red-50 text-red-700 border-red-200",
  media: "bg-amber-50 text-amber-700 border-amber-200",
  bassa: "bg-slate-100 text-slate-600 border-slate-200",
  da_fare: "bg-slate-100 text-slate-700 border-slate-200",
  in_corso: "bg-blue-50 text-blue-700 border-blue-200",
  completata: "bg-emerald-50 text-emerald-700 border-emerald-200",
  annullata: "bg-red-50 text-red-700 border-red-200",
  attivo: "bg-emerald-50 text-emerald-700 border-emerald-200",
  da_avviare: "bg-amber-50 text-amber-700 border-amber-200",
};

export function statusColor(key) {
  return STATUS_COLORS[key] || "bg-slate-100 text-slate-600 border-slate-200";
}
